@if (showPopup) {
<div class="popup-overlay" (click)="onClose()">
    <div class="popup-container" (click)="$event.stopPropagation()">
        <div class="popup-header">
            <h2>{{ title }}</h2>
        </div>

        <div class="popup-content">
            <p>{{ description }}</p>
        </div>

        <div class="popup-footer">
            <app-button [label]="cancelButtonLabel" [color]="cancelButtonColor" (clicked)="onCancel()"
                iconAfter="fa fa-times icon-small">
            </app-button>
            <app-button [label]="confirmButtonLabel" [color]="confirmButtonColor" (clicked)="onConfirm()"
                iconAfter="fa fa-check icon-small">
            </app-button>
        </div>
    </div>
</div>
}